import { alertVariants } from "@visiblethread/react-components";

import localhost from "../../../apis/localhost";
import {
  setAllowedSitesAuthenticated,
  setAllowedSitesConnecting,
  setConnectNotice,
  setDiscoveryError,
} from "../allowedSitesSlice";
import {
  POLL_INTERVAL,
  POLL_TIMEOUT,
  POPUP_BLOCKED,
  REQUEST_CONFIG,
  SIGN_IN_CANCELLED,
  SIGN_IN_TIMED_OUT,
} from "./allowedSitesConstants";
import {
  allowedSitesUrl,
  connectNotice,
  messageOf,
  redirectUnlessSharepointError,
} from "./allowedSitesUtils";
import { checkAllowedSitesAuthentication } from "./checkAllowedSitesAuthentication";

const waitForAuthentication = (dispatch, isCloudMode, authWindow) =>
  new Promise((resolve) => {
    const startedAt = Date.now();
    const finish = (authenticated, notice) => {
      if (notice) {
        dispatch(notice);
      }
      resolve(authenticated);
    };
    const poll = async () => {
      const authenticated = await dispatch(
        checkAllowedSitesAuthentication({ isCloudMode })
      );
      if (authenticated) {
        if (!authWindow.closed) {
          authWindow.close();
        }
        finish(true);
        return;
      }
      if (authWindow.closed) {
        finish(false, connectNotice(alertVariants.warning, SIGN_IN_CANCELLED));
        return;
      }
      if (Date.now() - startedAt >= POLL_TIMEOUT) {
        finish(false, connectNotice(alertVariants.warning, SIGN_IN_TIMED_OUT));
        return;
      }
      setTimeout(poll, POLL_INTERVAL);
    };
    poll();
  });

export const connectAllowedSitesAdmin =
  ({ isCloudMode }) =>
  async (dispatch) => {
    dispatch(setAllowedSitesConnecting(true));
    dispatch(setDiscoveryError(null));
    dispatch(setConnectNotice(null));
    try {
      const { data } = await localhost.get(
        allowedSitesUrl(isCloudMode, "/authorization"),
        REQUEST_CONFIG
      );
      dispatch(setAllowedSitesAuthenticated(false));
      const authWindow = window.open(data.url, "_blank");
      if (!authWindow) {
        dispatch(connectNotice(alertVariants.danger, POPUP_BLOCKED));
        return false;
      }
      return await waitForAuthentication(dispatch, isCloudMode, authWindow);
    } catch (error) {
      redirectUnlessSharepointError(error);
      dispatch(
        connectNotice(
          alertVariants.danger,
          messageOf(error, "Could not connect to SharePoint")
        )
      );
      return false;
    } finally {
      dispatch(setAllowedSitesConnecting(false));
    }
  };
